import React from 'react'
import { observer } from 'mobx-react'

import Dialog from 'components/dialog/Dialog'
import Card from 'components/card/Card'
import Mousetrap from 'components/mousetrap/Mousetrap'
import Key from './Key'

import getShortcuts from 'utils/getShortcuts'

import styles from './shortcutDialog.scss'

interface IProps {
  onClose: () => void
}

class ShortcutDialog extends React.PureComponent<IProps> {
  handleClose = () => {
    this.props.onClose()
  }

  render() {
    const shortcutList = getShortcuts()
    const platformKeys = /Mac|iPod|iPhone|iPad/.test(navigator.platform)
      ? 'mac'
      : 'windowsAndLinux'
    return (
      <>
        <Dialog
          className={styles.container}
          title="Shortcuts"
          onClose={this.handleClose}
        >
          <div className={styles.content}>
            {shortcutList.sections.map(section => (
              <Card key={section.name} className={styles.section}>
                <>
                  <div className={styles.sectionName}>{section.name}</div>
                  {section.shortcuts.map(shortcut => (
                    <div key={shortcut.name} className={styles.row}>
                      <div className={styles.name}>{shortcut.name}</div>
                      <div className={styles.keys}>
                        {shortcut[platformKeys].map((keys, idx) => {
                          return (
                            <React.Fragment key={idx}>
                              {idx > 0 && (
                                <span className={styles.separator}>/</span>
                              )}
                              {keys.split('+').map(k => (
                                <Key key={k} type={k} />
                              ))}
                            </React.Fragment>
                          )
                        })}
                      </div>
                    </div>
                  ))}
                </>
              </Card>
            ))}
          </div>
        </Dialog>
        <Mousetrap keys="esc" onMatch={this.handleClose} />
      </>
    )
  }
}

export default observer(ShortcutDialog)
